import { Row, Col, Card, Typography } from 'antd';
import {
  UserOutlined, TeamOutlined, BookOutlined, ThunderboltOutlined,
  RiseOutlined, FireOutlined,
} from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';

interface OverviewData { data: { dau: number; mau: number; totalDecks: number; totalInteractions: number; totalTeachers: number; totalStudents: number } }

const statCards = [
  { key: 'dau',               label: 'Daily Active Users',     icon: <FireOutlined />,          accent: '#f59e0b', bg: '#fef3c7' },
  { key: 'mau',               label: 'Monthly Active Users',   icon: <RiseOutlined />,          accent: '#10b981', bg: '#d1fae5' },
  { key: 'totalDecks',        label: 'Active Decks',           icon: <BookOutlined />,          accent: '#6366f1', bg: '#ede9fe' },
  { key: 'totalInteractions', label: 'Monthly Interactions',   icon: <ThunderboltOutlined />,   accent: '#ec4899', bg: '#fce7f3' },
  { key: 'totalTeachers',     label: 'Active Teachers',        icon: <TeamOutlined />,          accent: '#3b82f6', bg: '#dbeafe' },
  { key: 'totalStudents',     label: 'Active Students',        icon: <UserOutlined />,          accent: '#8b5cf6', bg: '#ede9fe' },
];

export default function DashboardPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-overview'],
    queryFn: () => api.get<unknown, OverviewData>('/admin/analytics/overview'),
  });

  const stats = data?.data;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Typography.Title level={4} style={{ margin: 0, color: '#0f172a' }}>Dashboard</Typography.Title>
        <Typography.Text style={{ color: '#64748b', fontSize: 13 }}>Platform overview and key metrics</Typography.Text>
      </div>

      <Row gutter={[16, 16]}>
        {statCards.map(({ key, label, icon, accent, bg }) => {
          const value = stats?.[key as keyof typeof stats] ?? 0;
          return (
            <Col xs={24} sm={12} lg={8} key={key}>
              <Card loading={isLoading} style={{ border: '1px solid #e2e8f0', borderRadius: 12 }} styles={{ body: { padding: '20px 24px' } }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontSize: 28, fontWeight: 800, color: '#0f172a', lineHeight: 1.1 }}>
                      {value.toLocaleString()}
                    </div>
                    <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>{label}</div>
                  </div>
                  <div style={{ width: 42, height: 42, borderRadius: 10, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: accent, fontSize: 18 }}>
                    {icon}
                  </div>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
